import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB } from "@faire/web-api--source/indigofair/settings/NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB";

import { useIsSemDiscoverPage } from "../lib/useIsSemDiscoverPage";

const useSettingPerfAppSemDiscover = (): IThreeVariantXP => {
  return useSetting(
    NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB,
    IThreeVariantXP.Bucket.CONTROL
  );
};

export const useSettingIsPerfAppSemDiscoverTreatment = (): boolean => {
  const settingPerfAppSemDiscover = useSettingPerfAppSemDiscover();
  const isSemSimplifiedLpEnabled = useIsSemDiscoverPage();
  return (
    settingPerfAppSemDiscover !== IThreeVariantXP.Bucket.CONTROL &&
    isSemSimplifiedLpEnabled
  );
};
